export const locale = {
    'ORDERSLIST': {
        'TITLE': 'Orders list',
        'RESET_FILTERS' : 'Reset Filters',
        'ACCEPT': 'Accept',
        'RESET': 'Reset',
    },
    'VEHICLE.GROUP.ALL': 'All',
};
